import React, { FunctionComponent } from 'react';

import styled, { css } from 'styled-components';

import { getStatusLabelMerch } from '@webapp/store/release/selectors';

import { ReleaseStatus } from '@common/types/release/relase-status';

import { MerchProductStatus } from '@services/merch/types/api/merch-product-status';

import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';

interface StatusLabelMerchProps {
  status?: MerchProductStatus;
  releaseDate?: Date | string;
  approved?: boolean;
}

const StatusLabelMerch: FunctionComponent<StatusLabelMerchProps> = ({
  status,
  releaseDate,
  approved,
}) => {
  const text = getStatusLabelMerch(status, releaseDate, approved);
  return (
    <Label alignItems="center" justifyContent="center">
      <LabelText
        status={status}
        approved={approved}
        capitalize
        weight="700"
        type="small"
      >
        {text}
      </LabelText>
    </Label>
  );
};

export default StatusLabelMerch;

const Label = styled(Flex)`
  padding: 8px;
  border-radius: 100px;
  background-color: ${({ theme }) => theme.colors.white};

  ${({ theme }) => `@media screen and ${theme.device.laptop}`} {
    width: 100%;
    max-width: 100px;
  }
`;

const LabelText = styled(Typography)<{
  status?: ReleaseStatus | MerchProductStatus;
  approved?: boolean;
}>`
  text-align: center;
  color: ${({ theme }) => theme.colors.black};
  min-width: 100px;
  max-width: 120px;

  @media ${({ theme }) => theme.device.tablet} {
    min-width: auto;
  }

  color: ${({ status, approved }) =>
    status === 'draft' || status === 'pending'
      ? css`
          ${({ theme }) => theme.colors.tertiary}
        `
      : status === 'published'
      ? css`
          ${({ theme }) => theme.colors.black}
        `
      : status === 'taken-down'
      ? css`
          ${({ theme }) => theme.colors.error}
        `
      : status === 'processing'
      ? css`
          ${({ theme }) => theme.colors.upload}
        `
      : approved
      ? css`
          ${({ theme }) => theme.colors.primary}
        `
      : css`
          ${({ theme }) => theme.colors.tertiary}
        `};
`;
